import { withStyles, Container } from "@material-ui/core";
import React from "react";
import styles from "./styles";
import { NavLink } from "react-router-dom";

function Project(props) {
  return (
    <div style={{ marginTop: 20 }}>
      <Container>
        <h1 style={{ textAlign: "center" }}>
          Không tìm thấy trang này, trở về trang chủ tại
          <NavLink style={{ marginLeft: 5, color: "#2ac17f" }} to="/">
            đây
          </NavLink>
        </h1>
      </Container>
    </div>
  );
}

export default withStyles(styles)(Project);
